"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var configuration_1 = require("../configuration");
var baseRpcConfig_1 = __importDefault(require("./baseRpcConfig"));
/**
 * #config WebWorkerRpcDriver
 */
function x() {} // eslint-disable-line @typescript-eslint/no-unused-vars
var WebWorkerRpcDriverConfigSchema = (0, configuration_1.ConfigurationSchema)('WebWorkerRpcDriver', {}, {
  /**
   * #baseConfiguration
   */
  baseConfiguration: baseRpcConfig_1.default,
  explicitlyTyped: true
});
exports.default = WebWorkerRpcDriverConfigSchema;